import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"

export default ({ article }) => (
  <div className="article-wrapper">
    <h3 className="article-title">
      <AniLink fade to={article.link}>
        {article.title}
      </AniLink>
    </h3>
    <span className="categ-date">
      {article.date.toLocaleString("en-us", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}
    </span>
    <p className="categ-content">
      <AniLink fade to={article.link}>
        <img
          src={article.image}
          className="attachment-list-thumbnail size-list-thumbnail wp-post-image"
          alt={article.title}
        />
      </AniLink>
      {article.excerpt}
      <AniLink fade className="read-plus" to={article.link}>
        read more ...
      </AniLink>
    </p>
  </div>
)
